import { Button } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Id } from '@feature/utils';

interface VerifyResearchPerfEvalButtonProps {
  evaluationId: Id;
}

export function VerifyResearchPerfEvalButton({ evaluationId }: VerifyResearchPerfEvalButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate({
      to: `/research-perf-eval/$evaluationId/report/gather`,
      params: { evaluationId: String(evaluationId) },
      search: true,
    });
  };

  return (
    <Button
      size="xs"
      onClick={onClick}
    >
      {t('researchPerfEval.verifyReporting')}
    </Button>
  );
}
